let state = {
  messages: [],
  isOpen: false,
  loaderVisible: false,
  inputDisabled: false,
}

let inputHandle = {
  get: () => "",
  set: () => {},
}

export const registerInputHandle = (get, set) => {
  inputHandle = { get, set }
}

export const getInputValue = () => inputHandle.get()
export const setInputValueExternal = (text) => inputHandle.set(text)

const listeners = new Set()

const subscribe = (listener) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const getSnapshot = () => state

const emit = () => {
  listeners.forEach((l) => l())
}

const setState = (partial) => {
  state = { ...state, ...partial }
  emit()
}

let nextId = 1
const uid = () => String(nextId++)

const addResponse = (text) => {
  setState({ messages: [...state.messages, { id: uid(), sender: "bot", text }] })
}

const addUser = (text) => {
  setState({ messages: [...state.messages, { id: uid(), sender: "user", text }] })
}

const addCustom = (component, props) => {
  setState({ messages: [...state.messages, { id: uid(), sender: "custom", component, props }] })
}

const clear = () => {
  setState({ messages: [] })
}

const toggleOpen = (value) => {
  setState({ isOpen: typeof value === "boolean" ? value : !state.isOpen })
}

const toggleLoader = (value) => {
  setState({ loaderVisible: typeof value === "boolean" ? value : !state.loaderVisible })
}

const toggleInputDisabled = (value) => {
  setState({ inputDisabled: typeof value === "boolean" ? value : !state.inputDisabled })
}

const markAllAsRead = () => {
  // no unread tracking in this widget; kept for API parity
}

export const chatStore = {
  subscribe,
  getSnapshot,
  addResponse,
  addUser,
  addCustom,
  clear,
  toggleOpen,
  toggleLoader,
  toggleInputDisabled,
  markAllAsRead,
}
